/**
 * @file Syncs an investment's profile name across its joint, SDIRA and entity profiles.
 */
import type { Investment } from "../../types";

type NamedInvestment = Pick<Investment, "name" | "profileJoint" | "profileSdira" | "profileEntity">;

/**
 * Copies the investment's name into the profile name of whichever profile type it has.
 */
const updateProfileNames = (investment: NamedInvestment): void => {
  const { name } = investment;

  if (investment.profileEntity) {
    investment.profileEntity.profileName = name;
  }

  if (investment.profileSdira) {
    investment.profileSdira.profileName = name;
  }

  if (investment.profileJoint) {
    investment.profileJoint.profileName = name;
  }
};

export default updateProfileNames;
